export default "__VITE_ASSET__iOJSRpmU__"